/*stock : {
    id:
    product_id:
    shop_id:
    quantity:
}*/

export function inventoryReducer(state = {
    WAITING_DELIVERY:{},
    RESERVATION:{},
    OCCASION:{},
    AVAILABLE:{},
    COMMERCIAL:{},
    PREPA:{},
    ARRIVAGE:{},
    SAV:{},
    DEFECTIVE:{},
    LEASING:{},
    END_LEASING:{},
    OUT:{},
}, {
    type,
    payload
}){
    
    switch(type){
        case "GET_INVENTORY":
            let status = {
                WAITING_DELIVERY:{},
                RESERVATION:{},
                OCCASION:{},
                AVAILABLE:{},
                COMMERCIAL:{},
                PREPA:{},
                ARRIVAGE:{},
                SAV:{},
                DEFECTIVE:{},
                LEASING:{},
                END_LEASING:{},
                OUT:{},
            }

            Object.values(payload).forEach( stock  => {
                if (!status[stock.status]) {
                    status[stock.status] = {}
                }
                status[stock.status][stock.id] = stock
            })
            
            return status;

        // case "GET_SINGLE_STOCKS":
        //     let list = Object.assign({}, state)
        //     list[payload.status] = {...payload.list}

        //     return list;
        case "GET_RETURN_STOCKS":
            let list2 = Object.assign({}, state)
            list2.OCCASION = payload

            return list2;

        default:
            return state;
    }

}